import React from 'react'
import PropTypes from 'prop-types'
import { Form as FinalForm } from 'react-final-form'
import { RailsForm } from '@support/RailsForm'
import Form, { validate } from './Form'

const New = ({ model, variables, o }) => (
  <RailsForm
    component={FinalForm}
    action='create'
    url={`/v4/o/${o}/admin/equipment_measures`}
    successUrl={`/v4/o/${o}/admin/equipment_measures?equipment_id=${model.equipment_id || ''}&variable=${model.variable || ''}`}
    validate={validate}
    initialValues={model}
    render={(props) => (
      <Form
        title={I18n.t('v4/equipment_measures.new.title')}
        variables={variables}
        o={o}
        {...props}
      />
    )}
  />
)

New.propTypes = {
  model: PropTypes.object
}

New.defaultProps = {
  model: {},
  variables: []
}

export default New
